import { useState } from 'react';
import { toast } from 'sonner';
import { Mail, Sparkles } from 'lucide-react';
import { HOME } from '@/constants/testIds';
import { FadeIn } from '@/components/common/SectionTitle';
import { api, formatApiError } from '@/lib/api';

const Newsletter = () => {
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!email || !email.includes('@')) {
      toast.error('Please enter a valid email');
      return;
    }
    setSubmitting(true);
    try {
      await api.post('/public/newsletter', { email: email.trim() });
      toast.success('Subscribed! We\'ll send the GenAI Automation roadmap to your inbox.');
      setEmail('');
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section className="relative py-24">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <FadeIn>
          <div className="relative glass-strong rounded-3xl p-8 sm:p-12 overflow-hidden">
            <div className="absolute -top-32 -right-32 w-96 h-96 rounded-full bg-brand-cyan/10 blur-3xl" />
            <div className="absolute -bottom-32 -left-32 w-96 h-96 rounded-full bg-blue-500/10 blur-3xl" />
            <div className="relative">
              <div className="inline-flex items-center gap-2 text-xs tracking-[0.3em] uppercase text-brand-cyan/90 font-mono">
                <Sparkles className="w-3.5 h-3.5" /> Insider Newsletter
              </div>
              <h2 className="mt-3 font-display text-3xl sm:text-4xl font-black tracking-tight font-semibold">
                Get the <span className="text-brand-cyan">GenAI Automation Roadmap</span>
              </h2>
              <p className="mt-3 text-white/70 max-w-2xl">
                Free 90-day blueprint covering Selenium, Playwright, Appium & AI workflows. Plus exclusive job leads & mentorship invites.
              </p>
              <form onSubmit={onSubmit} className="mt-6 flex flex-col sm:flex-row gap-3 max-w-xl">
                <div className="relative flex-1">
                  <Mail className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-white/40" />
                  <input
                    type="email"
                    data-testid={HOME.newsletterInput}
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="you@company.com"
                    className="w-full pl-11 pr-4 py-3.5 rounded-lg bg-white/5 border border-white/10 focus:border-brand-cyan/60 focus:outline-none placeholder:text-white/30"
                  />
                </div>
                <button
                  type="submit"
                  disabled={submitting}
                  data-testid={HOME.newsletterSubmit}
                  className="bg-brand-cyan text-black font-semibold px-6 py-3.5 rounded-lg btn-glow hover:bg-brand-cyanSoft transition disabled:opacity-60"
                >
                  {submitting ? 'Subscribing...' : 'Subscribe Free'}
                </button>
              </form>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>
  );
};

export default Newsletter;
